import {
  Autocomplete,
  Backdrop,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { all } from "axios";
import React, { useEffect, useState } from "react";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import { useGetTokenOrLogout } from "../../../utils/token";
export default function EditMissedMetaLeads({ selectedRowData }) {
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  console.log("selectedRowData", selectedRowData);

  const [firstName, setFirstName] = useState(
    selectedRowData?.first_name || null
  );
  const [campaignLoading, setCampaignLoading] = useState(true);
  const [gradlynkCampaign, setGradlynkCampaign] = useState(
    selectedRowData?.facebook_campaign_name || null
  );
  const [campiagnList, setCampaignList] = useState([]);
  const [stmCampaignName, setStmCampaignName] = useState(null);
  const [lastName, setLastName] = useState(selectedRowData?.last_name || null);
  const [email, setEmail] = useState(selectedRowData?.email || null);
  const [isdCode, setIsdCode] = useState(
    selectedRowData?.mobile_country_code || 91
  );
  const [mobile, setMobile] = useState(selectedRowData?.mobile || null);
  const [branchList, setBranchList] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(
    selectedRowData?.nearest_branch_id || null
  );
  const [serviceList, setServiceList] = useState([]);
  const [selectedService, setSelectedService] = useState(
    selectedRowData?.service_id || null
  );
  const [subserviceList, setSubserviceList] = useState([]);
  const [selectedsubService, setSelectedSubService] = useState(
    selectedRowData?.sub_service_id || null
  );
  const [CountryList, setCountryList] = useState([]);

  const phoneRegex = /^[1-9][0-9]{9}$/;
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  const [leadsourceTypelist, setLeadSourceTypelist] = useState([]);
  const [leadsourceType, setLeadSourceType] = useState(
    selectedRowData?.lead_source_type_id || null
  );
  const [subleadSourceTypeList, setSubleadSourceTypeList] = useState([]);
  const [subleadSourceType, setSubleadSourceType] = useState(
    selectedRowData?.sub_lead_source_type_id || null
  );
  const [errors, setErrors] = useState({
    firstName: false,
    email: false,
    isdCode: false,
    mobile: false,
    stmCampaignName: false,
  });

  const [assignToList, setAssignToList] = useState([]);
  const [assignToName, setAssignToName] = useState(null);
  const [loading, setLoading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}country`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = [...data].sort(
            (a, b) => a.phone_code - b.phone_code
          );
          const uniqueArray = sortedData.filter(
            (obj, index, self) =>
              index === self.findIndex((t) => t.phone_code === obj.phone_code)
          );

          setCountryList(uniqueArray);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setServiceList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          const subserviceData = sortedData.filter(
            (i) => i.service_id === selectedService?.id
          );
          setSubserviceList(subserviceData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedService]);

  console.log("selectedService", selectedService);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setBranchList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}leadsource`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          const filterdata = sortedData.filter((item) => item.is_active === 1);
          setLeadSourceTypelist(filterdata);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subleadsource`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setSubleadSourceTypeList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/getadvisors/${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setAssignToList(sortedData);
        } else {
          setAssignToList([]);
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        setAssignToList([]);
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedService]);

  const handleAssignTochange = (e, value) => {
    setAssignToName(value);
  };

  const handlefirstNameChange = (e) => {
    setFirstName(e.target.value);
    setErrors({ ...errors, firstName: !e.target.value });
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
    setErrors({
      ...errors,
      email: !emailValue || !emailRegex.test(emailValue),
    });
  };

  const handleChangeIsdCode = (e) => {
    setIsdCode(e.target.value);
    setErrors({ ...errors, isdCode: !e.target.value });
  };

  const handlemobileChange = (e) => {
    const mobileValue = e.target.value;
    setMobile(mobileValue);
    setErrors({
      ...errors,
      mobile: !mobileValue || !phoneRegex.test(mobileValue),
    });
  };

  const handleServiceChange = (value) => {
    setSelectedSubService(null);
    setSelectedService(value);
    setErrors({ ...errors, selectedService: !value });
  };

  const handleSubServiceChange = (event, value) => {
    setSelectedSubService(value);
    setErrors({ ...errors, selectedsubService: !value });
  };

  const handlebranchChange = (value) => {
    setSelectedBranch(value);
    setErrors({ ...errors, selectedBranch: !value });
  };

  const handleLeadsourceChange = (event, value) => {
    setLeadSourceType(value);
    setErrors({ ...errors, leadsourceType: !value });
  };

  const handleSubLeadsourceChange = (event, value) => {
    setSubleadSourceType(value);
    setErrors({ ...errors, subleadSourceType: !value });
  };

  const handleSubmit = async (event) => {
    if (
      !firstName ||
      !isdCode ||
      !mobile ||
      !selectedBranch ||
      !stmCampaignName ||
      !selectedService ||
      !selectedsubService ||
      !leadsourceType ||
      !subleadSourceType
    ) {
      setErrors({
        firstName: !firstName,
        isdCode: !isdCode,
        mobile: !mobile || !phoneRegex.test(mobile),
        selectedBranch: !selectedBranch,
        stmCampaignName :!stmCampaignName ,
        selectedService: !selectedService,
        selectedsubService: !selectedsubService,
        leadsourceType: !leadsourceType,
        subleadSourceType: !subleadSourceType,
      });

      return;
    }

    setLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const formdata = {
      first_name: firstName || null,
      last_name: lastName || null,
      email: email || null,
      mobile_country_code: isdCode,
      mobile: mobile || null,
      nearest_branch_id: selectedBranch?.id || null,
      service_id: selectedService?.id || null,
      sub_service_id: selectedsubService?.id || null,
      lead_source_type_id: leadsourceType?.id || null,
      sub_lead_source_type_id: subleadSourceType?.id || null,
      user_id: parseInt(userId),
      assign_to: assignToName?.user_id || null,
      campaign_id: stmCampaignName?.id,
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}meta-lead/${selectedRowData?.id}`,
        {
          method: "PUT",
          headers,
          body: JSON.stringify(formdata),
        }
      );

      const result = await response.json();

      if (response.ok) {
        showSnackbar("Enquiry Updated Successfully");
        setLoading(false);
        showSnackbar("Enquiry updated Successfully.");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setLoading(false);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setLoading(false);
      } else {
        showSnackbar(result.message, "error");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error sending data:", error);
      setLoading(false);
    }
  };

  const fetchRunningCampaigns = async () => {
    setCampaignList(true);

    let headers = {
      "Content-Type": "application/json",
    };

    const formdata = {
      user_id: parseInt(userId),

      campaign_type_id: [2],
    };
    try {
      const response = await fetch(
        `${API_ENDPOINT}campaign/running-campaigns`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(formdata),
        }
      );

      const result = await response.json();

      if (response.ok) {
     setCampaignList(result)


        const selectedCampaign = result.find(
          (i) => i.id === selectedRowData?.campaign_id?.id
        );

        setStmCampaignName(selectedCampaign || null);
        setCampaignLoading(false);
   
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
        setLoading(false);
      } else {
        showSnackbar(result.message, "error");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error sending data:", error);
      setLoading(false);
    }
  };

  console.log("")

  useEffect(() => {
    fetchRunningCampaigns()
  }, []);

  const handleStmCampaignChange = (value) => {
    setStmCampaignName(value);
  };

  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Typography
          variant="h4"
          color="secondary"
          fontWeight={800}
          marginRight={2}
        >
          {" "}
          Data is in process, please wait...
        </Typography>
        <CircularProgress color="secondary" />
      </Backdrop>

    
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={6} sm={6}>
            <Typography variant="h6">
              First Name
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <CustomTextFieldComp
              size="normal"
              value={firstName}
              onChange={handlefirstNameChange}
              InputProps={{
                style: { borderRadius: "10px" },
              }}
              fullWidth
            />
            {errors.firstName && (
              <Typography color="error" variant="caption">
                First name is required
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={6} lg={6} sm={6}>
            <Typography variant="h6">Last Name</Typography>
            <CustomTextFieldComp
              size="normal"
              value={lastName}
              onChange={handleLastNameChange}
              InputProps={{
                style: { borderRadius: "10px" },
              }}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6} lg={6} sm={6}>
            <Typography variant="h6">
              Email{" "}
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <CustomTextFieldComp
              size="normal"
              value={email}
              onChange={handleEmailChange}
              InputProps={{
                style: { borderRadius: "10px" },
              }}
              fullWidth
              // error={errors.email}
              //helperText={errors.email && "Valid Email is required"}
            />
            {/* {errors.email && (
              <Typography color="error" variant="caption">
                Email is required
              </Typography>
            )} */}
          </Grid>

          <Grid item xs={12} md={6} lg={6} sm={6} container>
            <Grid item xs={4} md={4} lg={3}>
              <Typography variant="h6">
                ISD Code
                <span
                  style={{
                    color: "red",
                    position: "absolute",
                    marginLeft: "4px",
                    fontSize: "1em",
                  }}
                >
                  *
                </span>
              </Typography>

              <CustomTextFieldComp
                size="normal"
                select
                value={isdCode}
                onChange={handleChangeIsdCode}
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                fullWidth
                defaultValue={91}
                SelectProps={{
                  MenuProps: {
                    sx: {
                      maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
                      width: 250,
                    },
                  },
                }}
                error={errors.isdCode}
              >
                {CountryList.map((country) => (
                  <MenuItem
                    men
                    key={country.phone_code}
                    value={country.phone_code}
                  >
                    {country.phone_code}
                  </MenuItem>
                ))}

                {errors.isdCode && (
                  <Typography color="error" variant="caption">
                    ISD Code is required
                  </Typography>
                )}
              </CustomTextFieldComp>
            </Grid>
            <Grid item xs={8} md={8} lg={9}>
              <Typography variant="h6">
                Mobile
                <span
                  style={{
                    color: "red",
                    position: "absolute",
                    marginLeft: "4px",
                    fontSize: "1em",
                  }}
                >
                  *
                </span>
              </Typography>

              <CustomTextFieldComp
                size="normal"
                type="number"
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                value={mobile}
                onChange={handlemobileChange}
                fullWidth
                // error={errors.mobile}
                // helperText={errors.mobile && "Valid Mobile is required"}
              />

              {errors.mobile && (
                <Typography color="error" variant="caption">
                  Mobile number is required
                </Typography>
              )}
            </Grid>
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h6">
              Nearest Branch
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>

            <CustomAutocompleteComp
              disablePortal
              value={selectedBranch}
              options={branchList}
              onChange={(event, value) => {
                console.log(value);

                handlebranchChange(value); // Passing only the value
              }}
              getOptionLabel={(option) => option.branch_name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    style: { borderRadius: "10px" },
                  }}
                />
              )}
              sx={{
                "& .MuiAutocomplete-listbox": {
                  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                  width: 250,
                },
              }}
            />

            {errors.selectedBranch && (
              <Typography color="error" variant="caption">
                Nearest Branch is required
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={6} lg={6} sm={6}>
            <Typography variant="h6">Facebook Campaign</Typography>
            <CustomTextFieldComp
              size="normal"
              value={gradlynkCampaign}
              // onChange={handlefirstNameChange}
              InputProps={{ readOnly: true, style: { borderRadius: "10px" } }}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h6">
              Stm Campaign
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>

            <CustomAutocompleteComp
              disablePortal
              value={stmCampaignName}
              options={campiagnList}
              onChange={(event, value) => {
                handleStmCampaignChange(value); // Passing only the value
              }}
               readOnly
              noOptionsText={
                      campaignLoading && campiagnList.length === 0
                        ? "Loading"
                        : ""
                    }
              getOptionLabel={(option) => option.campaign_name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    style: { borderRadius: "10px" },
                  }}
                />
              )}
              sx={{
                "& .MuiAutocomplete-listbox": {
                  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                  width: 250,
                },
              }}
            />

            {errors.stmCampaignName && (
              <Typography color="error" variant="caption">
                Campaign is required
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h6">
              Service
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>

            <CustomAutocompleteComp
              disablePortal
              value={selectedService}
              onChange={(event, value) => {
                handleServiceChange(value); // Passing only the value
              }}
              options={serviceList}
              getOptionLabel={(option) => option.service_name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    style: { borderRadius: "10px" },
                  }}
                />
              )}
              sx={{
                "& .MuiAutocomplete-listbox": {
                  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                  width: 250,
                },
              }}
            />

            {errors.selectedService && (
              <Typography color="error" variant="caption">
                Service is required
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h6">
              Sub Service
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>

            <CustomAutocompleteComp
              disablePortal
              value={selectedsubService}
              onChange={
                handleSubServiceChange // Passing only the value
              }
              options={subserviceList}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    style: { borderRadius: "10px" },
                  }}
                />
              )}
            />
            {errors.selectedsubService && (
              <Typography color="error" variant="caption">
                Sub Service is required
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h6">
              Lead Source Type
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>

            <CustomAutocompleteComp
              disablePortal
              value={leadsourceType}
              onChange={handleLeadsourceChange}
              options={leadsourceTypelist}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    style: { borderRadius: "10px" },
                  }}
                />
              )}
              sx={{
                "& .MuiAutocomplete-listbox": {
                  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                  width: 250,
                },
              }}
            />
            {errors.leadsourceType && (
              <Typography color="error" variant="caption">
                Lead source type is required
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h6">
              Sub Lead Source Type
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>

            <CustomAutocompleteComp
              disablePortal
              value={subleadSourceType}
              onChange={handleSubLeadsourceChange}
              options={subleadSourceTypeList}
              getOptionLabel={(option) => option.source_type}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    style: { borderRadius: "10px" },
                  }}
                />
              )}
              sx={{
                "& .MuiAutocomplete-listbox": {
                  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                  width: 250,
                },
              }}
            />
            {errors.subleadSourceType && (
              <Typography color="error" variant="caption">
                Sub lead source type is required
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h6">Assign To</Typography>
            <CustomAutocompleteComp
              disablePortal
              noOptionsText={
                assignToList.length == 0 ? "No advisor available" : ""
              }
              value={assignToName}
              onChange={handleAssignTochange}
              options={assignToList}
              getOptionLabel={(option) =>
                `${option.first_name ? option.first_name : ""} ${
                  option.last_name ? option.last_name : ""
                }`
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    style: { borderRadius: "10px" },
                  }}
                />
              )}
              sx={{
                "& .MuiAutocomplete-listbox": {
                  maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                  width: 250,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} lg={12} md={12} sm={12} textAlign="end">
            <Button
              color="secondary"
              variant="contained"
              style={{ borderRadius: "25px" }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
  
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
